import { Button, Col, Empty, Modal, Row, Table } from "antd"
import {useContext, useEffect, useRef} from "react";
import { useReactToPrint } from "react-to-print";
import { useMaestras } from "../../../hooks/useMaestras"
import {TemplateContext} from "../../../utils/template_context";


export const ModalBeneficiarios = ({ openModal, proyectosBeneficiarios, setOpenModal, obtenerProyectos }: any) => {

    //console.log(proyectosBeneficiarios)

    const { lineaConvocatorias, obtenerLineaConvocatorias } = useMaestras();

    const AceptarModal = () => {

        setOpenModal(false)
        obtenerProyectos();
    }

    const componentRef = useRef<any>();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: "pageStyles={'@media print { body { -webkit-print-color-adjust: exact; } @page { size: A4; margin: 200mm !important }}'}"
    });

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            obtenerLineaConvocatorias();
        }
        return () => {
            mounted = false
        }
    }, [])

    const context = useContext(TemplateContext);

    const columns: any = [
        {
            title: "No.",
            width: 60,
            // fixed: context.device === "md"? "left": false,
            // dataIndex: "",
            key: "index",
            render: (datos: any, record: any, idx: number) => (
                <div>{idx + 1}</div>
            )
        },
        {
            title: "Nombre proyecto",
            width: 150,
            dataIndex: "nombre_propuesta",
            key: "nombre_propuesta",
        },
        {
            title: "Nota final",
            width: 150,
            dataIndex: "nota_final",
            key: "nota_final",
            fixed: context.device === "lg"? "right": false,
        },
        {
            title: "Código",
            width: 150,
            key: "radicado",
            dataIndex: "radicado"
        },
        {
            title: "Linea",
            width: 150,
            render: (datos: any) => {
                return <div>{datos.linea_convocatoria}</div>
            }
        },
        {
            title: "Categorias",
            width: 150,
            render: (datos: any) => {
                return (
                    <>
                        {datos.categoria_linea_convocatoria}

                    </>
                );
            }


        },
    ]

    //console.log(proyectosBeneficiarios)

    return (
        <>
            <Modal
                style={{ top: 20, zIndex: 3, background: "transparent" }}
                visible={openModal}
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
                closable={false}
                closeIcon=""
                width={1000}
                maskStyle={{
                    zIndex: 3,
                    backgroundColor: "rgba(0,144,76,0.8)",
                }}
                className="modal-postulacion-exitosa"
            >
                <Row className="row-shadow">
                    <Row>
                        <Col span={24} className="font-size-22px font-family-Montserrat-Bold justify-content-center">
                            {/* {convocatoria.nombre_convocatoria} */}
                            Se ha guardado con éxito
                        </Col>
                        <Col span={24} className="font-size-16px font-family-Montserrat-Regular justify-content-center">
                            Se han guardado {proyectosBeneficiarios.length} proyectos beneficiarios correctamente
                        </Col>
                        <Col span={24} className="font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                            {/* {convocatoria.nombre_convocatoria} */}
                            Haga click en aceptar para continuar
                        </Col>

                    </Row>
                    <Row className="width-100">
                        <Col span={12} className="justify-content-flex-end">
                            <Button className="button-blanco-radius" onClick={handlePrint}>
                                DESCARGAR
                            </Button>
                        </Col>
                        <Col span={12} style={{ textAlign: "initial", paddingLeft: "8px" }}>
                            <Button className="button-azul-radius" onClick={AceptarModal}>
                                ACEPTAR
                            </Button>
                        </Col>
                    </Row>
                </Row>

                <Row className="row-shadow">
                    <Row gutter={[24, 24]} ref={componentRef} style={{ height: "239px", overflowY: "auto" }}>
                        <Table
                            dataSource={proyectosBeneficiarios}
                            style={{ borderTop: "1px solid #C4C4C4" }}
                            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                            pagination={false}
                            columns={columns}
                            size="small"
                            bordered={false}

                        />

                    </Row>
                </Row>
            </Modal>


        </>
    )
}
